<template>
	<svg
		xmlns:svg="http://www.w3.org/2000/svg"
		xmlns="http://www.w3.org/2000/svg"
		viewBox="7.146755218505859 47.93895721435547 195.70648193359375 201.1220703125"
		version="1.1"
	>
		<metadata>Calendar And Clock Icon</metadata>
		<g
			inkscape:label="calendar"
			inkscape:groupmode="layer"
			id="g915"
			style="display:inline"
		>
			<g
				id="g907"
				transform="matrix(3.2971191,0,0,3.2971191,-61.13988,-15.80425)"
			>
				<path
					d="m 30.35,19.333 v 2.76 h -9.639 v 10.697 3.4 36.625 h 44.781 c 3.595,0 6.519,-2.926 6.519,-6.52 V 36.19 32.79 22.093 h -9.64 v -2.76 h -3.399 v 2.76 H 48.061 v -2.76 h -3.399 v 2.76 H 33.75 v -2.76 z m 38.26,46.963 c 0,1.719 -1.398,3.119 -3.118,3.119 H 24.111 V 36.19 H 68.61 Z M 44.661,25.493 v 2.906 h 3.399 v -2.906 h 10.911 v 2.906 h 3.399 v -2.906 h 6.239 V 32.79 H 24.111 v -7.297 h 6.239 v 2.906 h 3.4 v -2.906 z"
					id="path893"
				></path>
				<path
					d="M 38.073,40.157 H 27.448 v 10.625 h 10.625 z m -3.4,7.225 h -3.825 v -3.824 h 3.825 z"
					id="path895"
				></path>
				<path
					d="M 51.673,40.157 H 41.048 v 10.625 h 10.625 z m -3.4,7.225 h -3.825 v -3.824 h 3.825 z"
					id="path897"
				></path>
				<path
					d="M 65.273,40.157 H 54.648 v 10.625 h 10.625 z m -3.4,7.225 h -3.825 v -3.824 h 3.825 z"
					id="path899"
				></path>
				<path
					d="M 38.073,54.476 H 27.448 v 10.625 h 10.625 z m -3.4,7.224 h -3.825 v -3.826 h 3.825 z"
					id="path901"
				></path>
				<path
					d="M 51.673,54.476 H 41.048 v 10.625 h 10.625 z m -3.4,7.224 h -3.825 v -3.826 h 3.825 z"
					id="path903"
				></path>
				<path
					d="M 65.273,54.476 H 54.648 v 10.625 h 10.625 z m -3.4,7.224 h -3.825 v -3.826 h 3.825 z"
					id="path905"
				></path>
			</g>
		</g>
		<g inkscape:groupmode="layer">
			<circle
				style="fill:#ffffff;fill-opacity:1;stroke-width:2.46968"
				id="path918"
				cx="156.58038"
				cy="201.26753"
				r="44.96637"
			></circle>
		</g>
		<g inkscape:groupmode="layer">
			<g
				style="clip-rule:evenodd;fill-rule:evenodd"
				id="g932"
				transform="matrix(3.8598712,0,0,3.8598712,110.21634,156.42414)"
			>
				<path
					d="M 12,0 C 18.623,0 24,5.377 24,12 24,18.623 18.623,24 12,24 5.377,24 0,18.623 0,12 0,5.377 5.377,0 12,0 Z m 0,1 C 18.071,1 23,5.929 23,12 23,18.071 18.071,23 12,23 5.929,23 1,18.071 1,12 1,5.929 5.929,1 12,1 Z m 0,11 h 6 v 1 H 11 V 4 h 1 z"
					id="path921"
				></path>
			</g>
		</g>
	</svg>
</template>

<script>
	export default {
		name: "CalendarIcon",
	};
</script>
